/** @file movePivot: a pivot pixel dragged by an image-px delta, in half-pixel steps, kept in the tile. */

/** `pivot + delta` rounded to the half pixel and clamped to `[0, size]` per axis (image px from the top-left). */
export function movePivot(size: readonly [number, number], pivot: readonly [number, number], delta: readonly [number, number]): [number, number] {
  const step = (k: 0 | 1): number => Math.min(size[k], Math.max(0, Math.round((pivot[k] + delta[k]) * 2) / 2));
  return [step(0), step(1)];
}
